import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { Notify, Dialog } from 'vant'
import { getUrlKey } from '@/utils/base'
import commondata from '@/commondata.js'
// create an axios instance
const service = axios.create({
  baseURL: GetServiceUrl(),
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 5000000, // request timeout
  paramsSerializer: function(params) {
    return qs.stringify(params, { indices: false })
  }, components: {
    [Notify.name]: Notify,
    [Dialog.name]: Dialog
  }
})
export function GetServiceUrl() {
  return GetServiceUrlBase() + '/userAPI/'
}

export function GetServiceUrlBase() {
  return 'https://storeapi.myssi.cn'
  // return 'http://192.168.2.51:2122'
  // return 'https://localhost:44341'
  // return 'https://api.diveboss.net'
  // return 'https://storeapi.myssi.cn'
}
export function GetSelfUrl() {
  var url = window.location.href
  var i = url.indexOf('/', 8) + 1
  var host = url.substring(0, i)
  return host
}

// 获取大系统类型 潜水掌柜:DiveBoss  SSI:SSI
export function GetSystemType() {
  return 'SSI'
}

// 判断大系统类型
export function CheckSystemType(system) {
  if (system.toLowerCase() === GetSystemType().toLowerCase()) {
    return true
  }
  return false
}

// request interceptor
service.interceptors.request.use(
  async(config) => {
    // // console.log('URL地址', window.location)
    // var system = window.location.host.split('.')[0]
    // // console.log('systemCode:', system)
    // if (commondata.systemBase !== system) {
    //   if (system !== 'm') {
    //     commondata.systemBase = system
    //     var newUrl = window.location.href.replace('://' + system, '://m')
    //     // console.log('替换了:', newUrl)
    //     window.location.href = newUrl
    //     return config
    //   } else {
    //     // console.log('替换了a:', commondata.systemBase)
    //     config.headers['sys'] = commondata.systemBase
    //   }
    // } else {
    //   // console.log('替换了b:', commondata.systemBase)
    //   config.headers['sys'] = commondata.systemBase
    // }
    // console.log('head system', config.headers['sys'])
    // console.log('config.url', config.url)
    console.log('现在的系统:' + commondata.systemBase)
    config.headers['sys'] = commondata.systemBase
    if (config.url.indexOf('/user/GetWxLoginUrl') >= 0 ||
        config.url.indexOf('/data/getEnumList') >= 0 ||
        config.url.indexOf('/data/getStoreBase') >= 0 ||
        config.url.indexOf('/data/getArea') >= 0 ||
        config.url.indexOf('/user/wechatProSystemList') >= 0 ||
        config.url.indexOf('/user/wechatLogin') >= 0 ||
        config.url.indexOf('/user/aliPayLogin') >= 0 ||
        config.url.indexOf('/data/getWxShare') >= 0 ||
        config.url.indexOf('/ThirdActivitie/') >= 0) {
      return config
    }
    // const token = 'eyJ1IjoxLCJuIjoi5byg5LiJIiwiZSI6IjIwMTktMDUtMTVUMDI6NDQ6MDguNDkzNDhaIiwicyI6IkU0NEI0MkQ2NjBGNDc0RkQ5ODg1MUI4OERFMDlDRDEzRjdEMkRDNDNCN0E4QzM3ODk5ODU4QzYyOEM1NkQyRjQifQ=='
    var token = getToken()// store.getters.token

    // 支付宝登录代码
    var userAgentBody = navigator.userAgent
    var code = getUrlKey('alipayCode')
    if (userAgentBody.indexOf('AlipayClient') > 0 && code) {
      await store.dispatch('user/getAlipayLogin', code).then(response => {
        if (response && response.success) {
          token = response.data.token
          config.headers['DBoss'] = token
        } else {
          Dialog.alert({
            title: '重新登录!',
            message: '因为一些原因，登录失败，请稍后刷新尝试或者联系客服:' + response.message
          }).then(() => {
          })
        }
      })
      return config
    }
    // 支付宝登录代码结束

    if (token) {
      config.headers['DBoss'] = token
    } else {
      // 跳转出去进行微信登录
      var Backrouter = router.history.current.fullPath
      const base32 = require('base32')
      // alert('Backrouter:' + Backrouter)
      var url = GetSelfUrl() + 'loginCallback?system=' + commondata.systemBase + '&url=' + base32.encode(Backrouter)
      console.log('跳转页面去登录:', url)
      // alert('跳转页面去登录:' + url)
      await store.dispatch('user/getWxLoginUrl', url).then(response => {
        console.log('跳转页面去登录', response)
        window.location.href = response
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config.url.indexOf('/data/getArea') >= 0) {
      return response.data
    }
    if (response.config.url.indexOf('/data/getStoreBase') >= 0) {
      return response.data
    }
    const res = response.data
    console.log('respinse', res)
    if (res.code !== 0) {
      Notify(res.message || 'error')
    }
    if (res.code === 1001 || res.code === 1002 || res.code === 1000 || res.code === 1003) {
      // Dialog.alert({
      //   title: '重新登录!',
      //   message: '因为一些原因，您已经掉线，现在需要重新登录'
      // }).then(() => {
      //   // 跳转出去进行微信登录
      //   var Backrouter = router.history.current.fullPath
      //   var url = GetSelfUrl() + 'loginCallback?system=' + commondata.systemBase + '&url=' + Backrouter
      //   store.dispatch('user/getWxLoginUrl', url).then(response => {
      //     console.log('跳转页面去登录', response)
      //     window.location.href = response
      //   })
      // })
      const base32 = require('base32')
      Notify('因为一些原因，您已经掉线，现在正在重新登录')
      var Backrouter = router.history.current.fullPath
      var url = GetSelfUrl() + 'loginCallback?system=' + commondata.systemBase + '&url=' + base32.encode(Backrouter)
      store.dispatch('user/getWxLoginUrl', url).then(response => {
        console.log('跳转页面去登录', response)
        window.location.href = response
      })
    }
    // else if (res.code === 1005) {
    //   router.push('/users/regPhone')
    // } else if (res.code === 1006) {
    //   router.push('/users/bindSSI')
    // }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
